import React from "react";
import { ConfigProvider, theme } from "antd";
import Router from "./router";
import esES from "antd/es/locale/es_ES";
import LoginCognitoPage from "./pages/Inicio/component/LoginCognitoPage";
import { BrowserRouter } from "react-router-dom";
import Loading from "./components/layouts/Loading";
import { useAuth } from "react-oidc-context";

function App() {
  const auth = useAuth();

  const signOutRedirect = () => {
    const clientId = process.env.REACT_APP_COGNITO_CLIENTID_AZ;
    const logoutUri = process.env.REACT_APP_COGNITO_REDIRECT;
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMINIO;
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;
  };

  if (auth.isLoading) {
    return <Loading />;
  }

  if (auth.error) {
    return <div>Error de autenticación: {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <ConfigProvider
        locale={esES}
        theme={{
          algorithm: theme.defaultAlgorithm,
          token: {
            colorPrimary: "#7AC142",
            borderRadius: 10,
          },
        }}
      >
        <BrowserRouter>
          <Router
            logoutLocalFuntion={() => auth.removeUser()}
            logoutglobalFuntion={signOutRedirect}
          />
        </BrowserRouter>
      </ConfigProvider>
    );
  }

  return <LoginCognitoPage actionFuntion={() => auth.signinRedirect()} />;
}

export default App;
